// extracted by mini-css-extract-plugin
export default {"citiesListWrapper":"classes_citiesListWrapper__8cCRs"};